import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';

export const getRevisionComponentCountQueryKey = (
  revisionLocator: string,
): QueryKey => ['binary', revisionLocator, 'components', 'count'];

function getRevisionComponentCount(revisionLocator: string) {
  return get<{ count: number }>(`/api/binary/revision/${nuc(revisionLocator)}/components/count`, false);
}

/**
 * Helper hook for fetching the number of components in a given revision.
 * @param {string} revisionLocator - The revision locator of the user's revision.
 * @param {boolean} shouldFetch - Whether to fetch the number of components.
 * @returns A query for the number of components in the given revision.
 */
export default function useGetRevisionComponentCount(revisionLocator: string, shouldFetch = true) {
  return useQuery<{ count: number }>({
    queryKey: getRevisionComponentCountQueryKey(revisionLocator),
    queryFn: () => getRevisionComponentCount(revisionLocator),
    enabled: shouldFetch,
  });
}
